export default __webpack_public_path__ + "static/media/all.93aa6812.png";